import { IAplosApiRequestArgs } from "@/services/aplosApi";
import { AplosFileStatus } from "./AplosFileStatus";
import { AplosFileCategory } from "./AplosFileCategory";

export interface GetFilesArgsOptions {
    tenantId: string;
    userId: string;
    status?: AplosFileStatus;
    category?: AplosFileCategory;
}

export class GetFilesArgs implements IAplosApiRequestArgs {

    public tenantId: string;
    public userId: string;
    public status?: AplosFileStatus;
    public category?: AplosFileCategory;
    public executionId?: string;

    constructor(options: GetFilesArgsOptions) {
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.userId == null) throw Error("userId is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.status = options.status;
        this.category = options.category;
    }

}